import { PostType, type Post } from '@prisma/client';
import { Link, useLoaderData } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'
import { formatMonthAsText, formatDayAsText } from '#app/utils/date.ts'
import { getAllPosts } from '#app/utils/posts.server.ts'
import { type Route } from './+types/index.ts'

export const meta = ({ loaderData }: Route.MetaArgs) => {
	// const searchQuery = new URLSearchParams(
	// 	location.search
	//   ).get("q");
    // return [{ title: `Search results for "${searchQuery}"` }];

	var title = `JaseOwns - ${loaderData?.totalCount} Blog Posts`;
	var description = "Dive into a world where code and online nerdiness come together! Get a glimpse into my life and things I've learned over the years.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "blog,games,uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/blogs/blog-posts-root.png"},
		{ property: "og:image:alt", content: "Blog Posts in orange and white with black background"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

//const getDaysInMonth = (year:any, month:any) => new Date(year, month, 0).getDate()

// const addMonths = (input:any, months:any) => {
//   const date = new Date(input)
//   date.setDate(1)
//   date.setMonth(date.getMonth() + months)
//   date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)))
//   return date
// }

export async function loader({ request }: Route.LoaderArgs) {

	const posts = await getAllPosts(PostType.BLOG)

	const recentPosts = posts.filter(x => {
		var sixMonthsAgo = new Date();
		sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
		if (x.publishedAt.getFullYear() < sixMonthsAgo.getFullYear()) return false;
		return x.publishedAt.getTime() >= sixMonthsAgo.getTime()
	});
	const olderPosts = posts.filter(x => {
		var sixMonthsAgo = new Date();
		sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
		if (x.publishedAt.getFullYear() < sixMonthsAgo.getFullYear()) return true;
		return x.publishedAt.getTime() < sixMonthsAgo.getTime()
	});

	
	return {
			recentPosts,
			olderPosts,
			totalCount: posts.length,
		}
}

function displayListOfPosts(posts: Post[]) {
	var yearKey = "";
	var monthKey = "";

	return <div className="">{posts.map(x => {
		var yearSplit = <></>
		var monthSplit = <></>
		var theDate = new Date(x.publishedAt);

		if (yearKey != theDate.getFullYear().toString()) {
			yearSplit = <div className="dark:bg-cyan-900 max-w-md bg-cyan-600 text-white p-6 text-3xl font-bold my-6">{theDate.getFullYear()}</div>
			yearKey = theDate.getFullYear().toString();
			monthKey ="";
			monthSplit = <></>;
		}

		if (monthKey != theDate.getMonth().toString()) {
			monthSplit = <div className="text-2xl font-bold my-3">{formatMonthAsText(theDate.getMonth()+1)}</div>
			monthKey = theDate.getMonth().toString();
		}

		return <div className="px-4" key={x.id}>
			{yearSplit} {monthSplit} <div className="px-6 inline">{formatDayAsText(theDate.getDate())}</div> <Link className="underline hover:opacity-60 text-xl" to={`${x.slug}`}>{x.title}</Link>
		</div>
	})}
	</div>
}

export default function Index() {
	const data = useLoaderData<typeof loader>()

	// Convert string dates back to Date objects
	const convertPostDates = (post: any) => ({
		...post,
		publishedAt: new Date(post.publishedAt),
		lastUpdatedAt: new Date(post.lastUpdatedAt),
		createdAt: new Date(post.createdAt),
		updatedAt: new Date(post.updatedAt)
	});

	const recentPostsWithDates = data.recentPosts.map(convertPostDates);
	const olderPostsWithDates = data.olderPosts.map(convertPostDates);

	return (
		<main className="container mx-auto text-black dark:text-white">
			<h1 className="text-3xl px-10 text-cyan-900 dark:text-cyan-200">Blog Posts ({data.totalCount})</h1>
			<div className="px-10 my-6">
				<img src="/images/emotes/surprised_2048.png" className='h-24 float-left m-8' alt="surprised emote" />
				<div className="flex flex-col md:flex-row my-6">
					Welcome to a world where code and online nerdiness come together! Get a glimpse into my life and things I've learned over the years.
				</div>
			</div>
			{nextButtons()}

			<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">Recent Blog Posts ({data.recentPosts.length})</h1>
			{displayListOfPosts(recentPostsWithDates)}
			<h1 className="text-3xl px-4 mt-12 m-2 mb-6 text-cyan-900 dark:text-cyan-200">Older Blog Posts ({data.olderPosts.length})</h1>
			{displayListOfPosts(olderPostsWithDates)}
			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4 mt-10">
				{WatchCTA()}
			</div>
		</main>
	)
}



const nextButtons = () => {
return <div className="flex flex-col justify-center space-y-6 md:space-y-0 md:flex-row md:space-x-6 px-10 my-12 text-center md:text-left">
		<Link to="/about" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">Learn about Jase</Link>
		<Link to="/dev" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">View Projects</Link>
		<Link to="/videos" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">View Videos</Link>
	</div>
}
